import { getSessionStorage } from 'utility/browserStorageUtil';
import ApiClient from './ApiClient';

export const autoGenerateAllFrameEveryday = async (params: { orgId: string, targetDate: string }) => {
  const { data } = await ApiClient.post('/v1/autoGenerateAllFrameEveryDay/', params, {});
  return data;
};

export const getCustomerReservationList = async (params: any) => {
  const companyCode = getSessionStorage('companyCode');
  const { data } = await ApiClient.get(`/v1/getReservationList/${companyCode}`, params, {});
  return data;
};

export const updateReservation = async (
  reservationId: string,
  companyCode: string,
  body: { desiredTime?: string; cancelFlag?: boolean; cancelType?: number; contractCourseId?: string; orgId?: string },
) => {
  const { data } = await ApiClient.putJsonData(
    `/v1/reservations/${reservationId}`,
    { companyCode },
    body,
  );
  return data;
};

export const getReservationDetail = async (reservationId: string, companyCode: string) => {
  const { data } = await ApiClient.get(
    `/v1/reservations/${reservationId}/detail`,
    {},
    `companyCode=${companyCode}`,
  );
  return data;
};

export const getAvailableReservationForExistingClients = async (
  companyCode: string,
  startDate: string,
  endDate: string,
  orgId: string,
  contractCourseId: string,
  reservationId?: string,
) => {
  const { data } = await ApiClient.get(
    '/v1/reservations/bookingOnline/availableReservationForExistingClients',
    {},
    `companyCode=${companyCode}&startDate=${startDate}&endDate=${endDate}&orgId=${orgId}&contractCourseId=${contractCourseId}&reservationId=${reservationId || ''}`,
  );
  return data;
};
